import {ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { IMessengerConnector, Message } from '../../../../../types/all.type';
import {NgxModalDraggableDirective} from '../../../../../directives/draggable.directive';

@Component({
  selector: 'app-modal-message-pinned',
  templateUrl: './modal-message-pinned.component.html',
  styleUrls: ['./modal-message-pinned.component.scss']
})
export class ModalMessagePinnedComponent implements OnInit {
  @Input() modalMode = false;
  @Input() Service: IMessengerConnector;
  @Input() messages: Message[] = [];
  @Input() title: string;
  public modalDirective: NgxModalDraggableDirective;
  @ViewChild(NgxModalDraggableDirective)
  set setDirective(directive: NgxModalDraggableDirective) {
    this.modalDirective = directive;
  }
  constructor(private cd: ChangeDetectorRef, public bsModalRef: BsModalRef) {
    this.cd.detach();
  }

  ngOnInit(): void {
    this.messages.forEach((message) => {
      message.empty = false;
      message.delete = false;
      message.show = true;
    });
    this.cd.detectChanges();
  }
  trackByFn(index, element: any) {
    return element ? element.id : undefined;
  }
}
